export enum HeaderLogo {
  UW = 'UW',
}
